// extracted by mini-css-extract-plugin
export default {"container":"TeamLayout--container--5d7de4","contentWrapper":"TeamLayout--contentWrapper--1d1283","content":"TeamLayout--content--ea0f9a"};